import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Switch from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';

import { getPostRef, getPostIndexRef, getFolderIndexRef, getFileIndexRef } from '../../../../config/firebase';
import { getAllItems, updateLastUpdatedTimestamp } from '../../../../utils';
import Loader from '../../../../components/Loader'
import AutoComplete from '../../../../components/AutoComplete'
import MarkdownEditor from '../MarkdownEditor'

class PostForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: '',
      author: '',
      content: '',
      type: 'text',
      visibility: (props.visibility ? props.visibility : 'public'),
      selectedFile: null,
      selectedFolder: null,
      fileOptions: null,
      folderOptions: null,
      loaded: false,
    }

    this.postRef = getPostRef(this.props.postId, this.props.visibility);
    this.postsRef = getPostIndexRef();
    this.foldersRef = getFolderIndexRef();
    this.filesRef = getFileIndexRef();

    this.handleTypeChange           = this.handleTypeChange.bind(this)
    this.handleTextfieldChange      = this.handleTextfieldChange.bind(this)
    this.handleMarkdownEditorChange = this.handleMarkdownEditorChange.bind(this)
    this.handleSwitchToggle         = this.handleSwitchToggle.bind(this)
    this.handleFolderSelect         = this.handleFolderSelect.bind(this)
    this.handleFileSelect           = this.handleFileSelect.bind(this)
    this.handleSubmit               = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    if ( this.props.postId !== 'new' ) {
      this.postRef.on('value', (snapshot) => {
        if ( snapshot.val() ) {
          let data = snapshot.val();
          this.setState({
            title: data.title,
            author: data.author || '',
            content: data.content,
            type: data.type,
            loaded: true,
          }, () => this.loadFolderAndFileOptions(data.folder, data.mediaURL));
        }
      })
    } else {
      this.loadFolderAndFileOptions();
    }
  }

  componentWillUnmount() {
    this.postRef.off();
    this.foldersRef.off();
    this.filesRef.off();
  }

  loadFolderAndFileOptions(folderId = null, mediaURL = null) {
    getAllItems(this.foldersRef, (folders) => {
      const folderOptions = folders
        .filter(folder => folder.screen === this.props.screen)
        .map(({ id, title }) => ({ value: id, label: title }));

      let selectedFolder = folderOptions.find(({ value }) => value === folderId);
      selectedFolder = selectedFolder ? selectedFolder : null;

      this.setState({ folderOptions, selectedFolder });
    });

    getAllItems(this.filesRef, (files) => {
      const fileOptions = files.map(({ url, title, name }) => {
        const type = name.endsWith('.mp3') ? 'audio' : 'video';
        const label = title.replace(/\.mp(3|4)$/, '');

        return { value: url, label, type };
      });

      let selectedFile = fileOptions.find(({ value }) => value === mediaURL);
      selectedFile = selectedFile ? selectedFile : null;

      this.setState({ fileOptions, selectedFile });
    }, false);
  }

  handleSubmit(event) {
    event.preventDefault();

    const postData = {
      title: this.state.title,
      author: this.state.author,
      content: this.state.content,
      type: this.state.type,
      mediaURL: '',
      screen: this.props.screen,
      folder: '',
    }

    if (this.state.selectedFolder && this.state.selectedFolder.value) {
      postData.folder = this.state.selectedFolder.value;
    }

    if (this.state.selectedFile && this.state.selectedFile.value) {
      postData.mediaURL = this.state.selectedFile.value;
    }

    var postKey = this.props.postId === 'new'
      ? this.postsRef.push().key
      : this.props.postId;

    getPostRef(postKey, this.state.visibility).update(postData, (error) => {
      updateLastUpdatedTimestamp();
      if (this.state.visibility !== this.props.visibility && this.props.postId !== 'new' && !error) {
        // Remove old post if the post visibility has changed (ie. post has been moved to new location)
        getPostRef(postKey, this.props.visibility).remove()
      }
      this.setState({formState: 'saved'});
    });
    this.setState({formState: 'saving'});
  }

  handleTypeChange(event) {
    let type = event.target.value;
    this.setState({ type, selectedFile: null });
  }

  handleTextfieldChange(event) {
    let value = event.target.value
    let name = event.target.name
    this.setState({[name]: value})
  }

  handleMarkdownEditorChange(value) {
    this.setState({content: value})
  }

  handleFolderSelect(id) {
    const selectedFolder = this.state.folderOptions.find(f => f.value === id);
    this.setState({ selectedFolder })
  }

  handleFileSelect(url) {
    const selectedFile = this.state.fileOptions.find((file) => {
      return file.type === this.state.type && file.value === url;
    });
    this.setState({ selectedFile })
  }

  handleSwitchToggle() {
    let visibility = this.state.visibility === 'public' ? 'private' : 'public'
    this.setState({visibility})
  }

  render() {
    if (this.state.formState === 'saved') {
      return (
        <Redirect to={`/${this.props.screen}`} />
      )
    }

    if (
      (this.props.postId !== 'new' && !this.state.loaded)
      || this.state.formState === 'saving'
      || this.state.fileOptions === null
      || this.state.folderOptions === null
    ) {
      return (
        <Loader />
      )
    }

    const fileOptions = this.state.fileOptions
      ? this.state.fileOptions.filter(file => {
          return file.type === this.state.type;
        })
      : [{ value: '', label: 'loading...' }];

    const folderOptions = this.state.folderOptions
      ? this.state.folderOptions
      : [{ value: '', label: 'loading...' }];

    return (
      <div className="form-wrapper">
        <form onSubmit={this.handleSubmit} id="post-form">
          <TextField
            fullWidth
            label="Title"
            name="title"
            required
            value={this.state.title}
            onChange={this.handleTextfieldChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Author"
            name="author"
            value={this.state.author}
            onChange={this.handleTextfieldChange}
            margin="normal"
          />
          <div style={{height: 30}} />
          <MarkdownEditor
            title='Content'
            onChange={this.handleMarkdownEditorChange}
            value={this.state.content}
          />
          <FormControl component="fieldset">
            <FormLabel component="legend">Type</FormLabel>
            <RadioGroup
              aria-label="post type"
              name="type"
              value={this.state.type}
              onChange={this.handleTypeChange}
            >
              <FormControlLabel value="text" control={<Radio />} label="Text" />
              <FormControlLabel value="audio" control={<Radio />} label="Audio" />
              <FormControlLabel value="video" control={<Radio />} label="Video" />
            </RadioGroup>
          </FormControl>
          <br/>
          {this.state.type !== 'text' &&
            <AutoComplete
              label={this.state.type === 'audio' ? 'Audio file' : 'Video file'}
              options={fileOptions}
              selected={this.state.selectedFile}
              onChange={this.handleFileSelect}
            />
          }
          <AutoComplete
            label="Folder"
            options={folderOptions}
            selected={this.state.selectedFolder}
            onChange={this.handleFolderSelect}
          />
          <FormControlLabel
            control={
              <Switch
                checked={this.state.visibility === 'private' ? true : false}
                onChange={this.handleSwitchToggle}
                value="private"
              />
            }
            label="Private"
          />
          <br/>
          <br/>
          {this.props.children}
        </form>
      </div>
    )
  }
}

export default PostForm;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/PostForm/index.js